import { render, staticRenderFns } from "./MobileTask.vue?vue&type=template&id=1052f912&scoped=true"
import script from "./MobileTask.vue?vue&type=script&lang=js"
export * from "./MobileTask.vue?vue&type=script&lang=js"
import style0 from "./MobileTask.vue?vue&type=style&index=0&id=1052f912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1052f912",
  null
  
)

export default component.exports